import React, { useState } from 'react';
import { auth, db } from './firebaseConfig';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore'; 
import { useNavigate } from 'react-router-dom';
import { Lock, User, Eye, EyeOff } from 'lucide-react';

// ✅ FUNÇÃO DE NORMALIZAÇÃO EMBUTIDA
const normalizarCidade = (cidade: string): string => {
  return cidade
    .normalize("NFD")                    // Decompõe acentos
    .replace(/[\u0300-\u036f]/g, "")     // Remove acentos
    .toLowerCase()                       // Minúsculas
    .trim()
    .replace(/\s+/g, "_");               // Espaço → underscore
};

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [erro, setErro] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      const adminRef = doc(db, "admins", user.uid);
      const adminSnap = await getDoc(adminRef);

      if (adminSnap.exists()) {
        const adminData = adminSnap.data();
        
        // 🔹 Buscar cidade do admin (ou fallback)
        const cidadeDisplay = adminData.cidade || 'Ibirité';
        const cidadeNormalizada = normalizarCidade(cidadeDisplay);
        
        // 🔹 Salvar AMBAS no localStorage
        localStorage.setItem('cidadeDisplay', cidadeDisplay);        // "Ibirité" → UI
        localStorage.setItem('cidadeNormalizada', cidadeNormalizada); // "ibirite" → Queries
        
        navigate('/menu');
      } else {
        setErro("Acesso negado. Perfil administrativo não autorizado.");
        await auth.signOut();
      }
    } catch (error) {
      setErro("E-mail ou senha incorretos.");
    }
  };

  return (
    <div className="min-h-screen bg-[#6200EE] flex items-center justify-center p-6 font-sans relative overflow-hidden">
      {/* ... (JSX do login permanece igual) ... */}
      <div className="bg-white w-full max-w-md rounded-[3.5rem] p-12 shadow-2xl relative z-10">
        <div className="flex flex-col items-center mb-10">
          <div className="w-24 h-24 mb-6">
            <img src="/logo_ibiraco.png" alt="Logo Ibiraco" className="w-full h-full object-contain" />
          </div>
          <h1 className="text-4xl font-black text-[#6200EE] tracking-tighter leading-none italic">
            IBIRACO<span className="text-xl align-top text-[#e67e22]">®</span>
          </h1>
          <div className="h-1 w-12 bg-[#e67e22] rounded-full mt-2"></div>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <div className="relative group">
            <User className="absolute left-5 top-5 text-gray-300 group-focus-within:text-[#6200EE] transition-colors" size={20} />
            <input 
              type="email" 
              placeholder="E-mail Institucional"
              className="w-full pl-14 pr-6 py-5 bg-gray-50 border-2 border-transparent rounded-2xl font-bold text-sm focus:border-[#6200EE]/20 focus:bg-white outline-none transition-all"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="relative group">
            <Lock className="absolute left-5 top-5 text-gray-300 group-focus-within:text-[#6200EE] transition-colors" size={20} />
            <input 
              type={showPassword ? "text" : "password"}
              placeholder="Senha de Acesso"
              className="w-full pl-14 pr-14 py-5 bg-gray-50 border-2 border-transparent rounded-2xl font-bold text-sm focus:border-[#6200EE]/20 focus:bg-white outline-none transition-all"
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-5 top-5 text-gray-400 hover:text-[#6200EE] transition-colors"
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>

          {erro && (
            <p className="text-red-500 text-[10px] font-black text-center uppercase bg-red-50 py-3 rounded-xl border border-red-100 italic">
              {erro}
            </p>
          )}

          <button className="w-full bg-[#6200EE] text-white py-5 rounded-2xl font-black uppercase tracking-widest shadow-xl shadow-[#6200EE]/30 hover:bg-[#4800b2] active:scale-95 transition-all">
            Entrar no Painel
          </button>
        </form>
      </div>
    </div>
  );
}